"use client";
import React from "react";
import BugsnagClient from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { CustomNavigationClient, msalInstance } from "@/lib/sso";
import { AuthenticationResult, EventType } from "@azure/msal-browser";
import { useRouter } from "next/navigation";
import { MsalProvider } from "@azure/msal-react";
import { Providers } from "@/components/providers";

export const AppRoot = ({ children }: { children: React.ReactNode }) => {
    BugsnagClient.start({
        apiKey: "fe5d5244e80b247c4314b5f38bf9bdb4",
        plugins: [new BugsnagPluginReact()],
    });

    msalInstance.initialize().then(() => {
        // Account selection logic is app dependent. Adjust as needed for different use cases.
        const accounts = msalInstance.getAllAccounts();
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0]);
        }

        msalInstance.addEventCallback((event) => {
            const result = event.payload as AuthenticationResult | null;
            if (result) {
                if (event.eventType === EventType.LOGIN_SUCCESS && result.account) {
                    const account = result.account;
                    msalInstance.setActiveAccount(account);
                }
            }
        });
    });

    const router = useRouter();
    const navigationClient = new CustomNavigationClient(router);
    msalInstance.setNavigationClient(navigationClient);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const ErrorBoundary = BugsnagClient.getPlugin("react").createErrorBoundary(React);

    return (
        <ErrorBoundary>
            <MsalProvider instance={msalInstance}>
                <Providers>{children}</Providers>
            </MsalProvider>
        </ErrorBoundary>
    );
};
